module.exports = __webpack_public_path__ + "img/the-edge.d9ca2ab6.png";